import { render, staticRenderFns } from "./ServeDialog.vue?vue&type=template&id=8b7d4bca&scoped=true&"
import script from "./ServeDialog.vue?vue&type=script&lang=js&"
export * from "./ServeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7d4bca",
  null
  
)

export default component.exports